import React from 'react';
import Select from 'react-select';
import { Wrapper } from '../';
import styled from 'styled-components';

const SelectStyle = styled(Select)`
  width: 100%;
`;

const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: '9999',
  }),
};

const SelectExtended = ({
  label,
  register,
  placeholder,
  options = [],
  onChange,
  isMulti,
  defaultValue,
  width = '100%',
  ...rest
}) => {
  return (
    <Wrapper {...rest} width={width}>
      <SelectStyle
        styles={customStyles}
        name={label}
        placeholder={placeholder}
        defaultValue={defaultValue}
        inputRef={register}
        onChange={onChange}
        options={options}
        isMulti={isMulti}
      />
    </Wrapper>
  );
};

export default SelectExtended;
